import { render, staticRenderFns } from "./NcdTable.vue?vue&type=template&id=9c5b2698"
import script from "./NcdTable.vue?vue&type=script&lang=ts"
export * from "./NcdTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports